import {COUNTRY} from 'front-onceforall-core/dist/utils/country';
import {REGISTRATION_NUMBER_CODE, GROUP_NUMBER_CODE, VAT_IDENTIFICATION_NUMBER_CODE} from 'front-onceforall-core/dist/utils/organisations';

const identificationNumberTypesInDb = [
  {
    code: REGISTRATION_NUMBER_CODE,
    country: COUNTRY.GERMANY,
    format: '^\\d{8}$',
    inProgress: '^\\d{0,8}$',
    required: true
  },
  {
    code: REGISTRATION_NUMBER_CODE,
    country: COUNTRY.FRANCE,
    format: '^\\d{14}$',
    inProgress: '^\\d{0,14}$',
    required: true
  },
  {
    code: REGISTRATION_NUMBER_CODE,
    country: COUNTRY.SPAIN,
    format: '^ES[A-Z0-9]\\d{6}[A-Z0-9]$',
    inProgress: '^(E|ES)[A-Z0-9]?\\d{0,6}[A-Z0-9]?$',
    required: true
  },
  {
    code: GROUP_NUMBER_CODE,
    country: COUNTRY.FRANCE,
    format: '^\\d{9}$',
    inProgress: '^\\d{0,9}$',
    required: true
  },
  {
    code: VAT_IDENTIFICATION_NUMBER_CODE,
    country: COUNTRY.FRANCE,
    format: '^FR\\d{11}$',
    inProgress: '^(F|FR)\\d{0,11}$',
    required: false
  },
  {
    code: VAT_IDENTIFICATION_NUMBER_CODE,
    country: COUNTRY.GERMANY,
    format: '^DE\\d{9}$',
    inProgress: '^(D|DE)\\d{0,9}$',
    required: false
  },
  {
    code: VAT_IDENTIFICATION_NUMBER_CODE,
    country: COUNTRY.SPAIN,
    format: '(^ES[A-Z0-9]\\d{6}[A-Z0-9]$)',
    inProgress: '(^(E|ES)[A-Z0-9]?\\d{0,6}[A-Z0-9]?$)',
    required: true
  },
  {
    code: 'STEUERLICHE_IDENTIFIKATIONSNUMMER',
    country: COUNTRY.GERMANY,
    format: '^\\d{11}$',
    inProgress: '^\\d{0,11}$',
    required: false
  }
];

export default class FakeIdentificationNumberService {
  findAllByCountry(country) {
    const matchingIdentificationNumberTypes = identificationNumberTypesInDb
      .filter(identificationNumberType => identificationNumberType.country === country);

    return Promise.resolve(matchingIdentificationNumberTypes);
  }

  findAllRegistrationNumberType() {
    const matchingIdentificationNumberTypes = identificationNumberTypesInDb
      .filter(identificationNumberType => identificationNumberType.code === REGISTRATION_NUMBER_CODE);

    return Promise.resolve(matchingIdentificationNumberTypes);
  }
}
